import { render, staticRenderFns } from "./AddPassengers.vue?vue&type=template&id=48d5c36c&scoped=true"
import script from "./AddPassengers.vue?vue&type=script&lang=js"
export * from "./AddPassengers.vue?vue&type=script&lang=js"
import style0 from "./AddPassengers.vue?vue&type=style&index=0&id=48d5c36c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5c36c",
  null
  
)

export default component.exports